module.exports = {
      id: "kishoralo-usage",
      viewBox: "0 0 512 209.434",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#kishoralo",
      toString: function () {
        return this.url;
      }
    }